<script setup lang="ts">
import UIBanner from '@/shared/ui/Banner';
import ProductsSection from '@/pages/for-business/ui/productsSection.vue';
import AboutSection from '@/pages/for-business/ui/aboutSection.vue';
import FeaturesSection from '@/pages/for-business/ui/featuresSection.vue';
import ContactsSection from '@/pages/for-business/ui/contactsSection.vue';

const { t } = useI18n();

useSeoMeta({
  title: t('forBusinessPage.title'),
  ogTitle: t('forBusinessPage.title'),
  description: t('aboutCompanyDescription'),
  ogDescription: t('aboutCompanyDescription'),
  ogImage: 'https://resursi-distribution.uz/images/banners/about/about-banner.webp',
});
</script>

<template>
  <div class="for-business-page">
    <section class="for-business-page__section _banner">
      <h1 class="for-business-page__title">
        <span class="for-business-page__orange">Resursi Distribution:</span>
        {{ t('forBusinessPage.title') }}
      </h1>
      <div class="for-business-page__banner">
        <UIBanner
          :images="{
            desktop: '/images/banners/about/about-banner.webp',
            mobile: '/images/banners/about/about-banner-mobile.webp',
          }"
          is-hide-line-break
        />
      </div>
    </section>
    <section class="for-business-page__section _products">
      <ProductsSection />
    </section>
    <section class="for-business-page__section _about">
      <AboutSection />
    </section>
    <section class="for-business-page__section _features">
      <FeaturesSection />
    </section>
    <section class="for-business-page__section _contacts">
      <ContactsSection />
    </section>
  </div>
</template>

<style lang="less">
.for-business-page {
  .container-d();
  .flex-column(80px);

  padding-top: 80px;
  padding-bottom: 72px;

  &__title {
    .h-offset-reset();

    font-size: 64px;
    font-weight: 500;
    line-height: 110%;
    max-width: 1035px;
  }

  &__section {
    &._banner {
      .flex-column(56px);
    }
  }

  &__banner {
    height: 380px;
  }

  &__orange {
    color: @color-tango;
  }

  @media @1024 {
    .container-m();

    gap: @size-x10;
    padding-top: @size-x6;
    padding-bottom: 48px;

    &__title {
      font-size: 30px;
    }

    &__banner {
      height: 160px;
    }

    &__section {
      &._banner {
        .flex-column(@size-x6);
      }
    }
  }
}
</style>
